window.$ = jQuery;
import viewportHelper from "./utils/viewportHelper";
import { Application } from "@hotwired/stimulus";
import Header from "./component/header/header";

import HeroBanner from "./component/common/heroBanner";
import pushSlider from "./component/common/pushSlider";

import Testimonials from "./component/common/testimonials";
import ImageSlider from "./component/common/ImageSlider";
import DualSlider from "./component/common/DualSlider";
import Tabs from "./component/common/tabs";
import TextCarrouselSlider from "./component/common/TextCarrouselSlider";
import BlocksObserver from "./component/common/BlocksObserver";
import ExploreSpacesSlider from "./component/common/ExploreSpacesSlider";

window.Stimulus = Application.start()
Stimulus.register("header", Header);
Stimulus.register("hero-banner", HeroBanner);
Stimulus.register("push-slider", pushSlider);
Stimulus.register("testimonials", Testimonials);
Stimulus.register("image-slider", ImageSlider);
Stimulus.register("tabs", Tabs);
Stimulus.register("text-carrousel-slider", TextCarrouselSlider);
Stimulus.register("dual-slider", DualSlider);
Stimulus.register("blocks-observer", BlocksObserver);
Stimulus.register("explore-spaces-slider", ExploreSpacesSlider);


document.addEventListener('DOMContentLoaded', () => {
    viewportHelper.init();
});
